import { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import SecureAdServer from './SecureAdServer/index.jsx';
import { useAppContext } from '~/AppProviders.jsx';
import getGreeting from '~/utils/getGreeting.js';

function Dashboard() {
  const { userName } = useAppContext();
  const greeting = getGreeting();

  useEffect(() => {
    window.name = 'vmax-dashboard';
  }, []);

  return (
    <Box
      component="main"
      sx={{ p: { xs: 1, md: 2 } }}>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          mb: { xs: 2, md: 3 },
        }}>
        {greeting}, {userName}!
      </Typography>
      <SecureAdServer />
    </Box>
  );
}

export default Dashboard;
